import { Stack } from "@similarweb/ui-components/foundations";

import { isNonEmptyArray } from "app/helpers/arrays";
import { useKeywordLists } from "app/modules/demand-analysis/keyword-lists";
import DurationService from "app/services/DurationService";

import { KeywordGroupTable } from "./features/keyword-group-comparison-table";
import { KeywordGroupsScatterPlot } from "./features/keyword-lists-comparison";
import { KeywordsTrendsWidget } from "./features/keywords-trends-widget";
import SearchTrendsNotAvailablePage from "./features/search-trends-page/search-trends-not-available/SearchTrendsNotAvailablePage";
import SearchTrendsAiTopic from "./features/search-trends-page/SearchTrendsAiTopic";
import SearchTrendsAiTopicPoP from "./features/search-trends-page/SearchTrendsAiTopicPoP";
import SearchTrendsKeywords from "./features/search-trends-page/SearchTrendsKeywords";
import SearchTrendsKeywordsPoP from "./features/search-trends-page/SearchTrendsKeywordsPoP";
import SearchTrendsTerms from "./features/search-trends-page/SearchTrendsTerms";
import SearchTrendsTermsPoP from "./features/search-trends-page/SearchTrendsTermsPoP";
import { TrafficByCountry } from "./features/traffic-by-country";

export const DemandAnalysisSearchTrends = () => {
    const { keywordLists } = useKeywordLists();

    if (!isNonEmptyArray(keywordLists)) {
        return null;
    }

    const isPeriodOverPeriod = DurationService.isPeriodOverPeriod();
    const primaryKeywordList = keywordLists[0];
    const key = keywordLists.map((keywordList) => keywordList.id).join(";");

    switch (true) {
        case keywordLists.length > 1: {
            return (
                <Stack
                    gap="24px"
                    key={key}
                >
                    <KeywordsTrendsWidget />
                    <TrafficByCountry />
                    <KeywordGroupsScatterPlot />
                    <KeywordGroupTable />
                </Stack>
            );
        }
        case primaryKeywordList.type === "keywordGroup" && isPeriodOverPeriod:
            return <SearchTrendsKeywordsPoP key={key} />;
        case primaryKeywordList.type === "keywordGroup" && !isPeriodOverPeriod:
            return <SearchTrendsKeywords key={key} />;
        case primaryKeywordList.type === "searchTerm" && isPeriodOverPeriod:
            return <SearchTrendsTermsPoP key={key} />;
        case primaryKeywordList.type === "searchTerm" && !isPeriodOverPeriod:
            return <SearchTrendsTerms key={key} />;
        case primaryKeywordList.type === "aiTopic" && isPeriodOverPeriod:
            return <SearchTrendsAiTopicPoP key={key} />;
        case primaryKeywordList.type === "aiTopic" && !isPeriodOverPeriod:
            return <SearchTrendsAiTopic key={key} />;
        default:
            return <SearchTrendsNotAvailablePage keyword={primaryKeywordList.name} />;
    }
};
